import { createFileRoute } from '@tanstack/react-router'
import { legalRouteOptions } from '@/lib/cms/legal-route'

export const Route = createFileRoute('/acceptable-use')(
  legalRouteOptions('acceptable-use'),
)
